<template>
	<div class="">
		<!--header-->
		<app-header headerTitle="نوع ارسال را انتخاب کنید"></app-header>

		<!--loading-->
		<div class="loading text-center px-3" v-if="loading">
			<div class="alert alert-blue d-inline-block py-2 px-3">
				<i class="fa fa-refresh fa-spin ml-1 align-middle"></i> در حال بارگذاری ...
			</div>
		</div>

		<div v-else>
			<div class="shipping px-3">
				<div class="shipping-types my-4">
					<div class="card mb-4" :key="shipping.id" v-for="shipping in shippings">
						<div class="card-body bg-light text-center">
							<h5 class="card-title">
								{{ shipping.title }}
							</h5>
							<p class="card-text mb-0" v-if="shipping.description">
								{{ shipping.description }}
							</p>
							<div class="shipping-price my-3">
								<span v-if="shipping.cost">{{ shipping.cost }} <small>تومان</small></span>
								<span v-else>رایگان</span>
							</div>
							<button type="button" class="btn btn-block btn-green" @click="selectedShipping(shipping.id)">
								{{ progress ? 'کمی صبر کنید ...': 'انتخاب این روش' }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from "../components/Header.vue"
	import axios from 'axios'
	export default {
		components: {
			appHeader: Header
		},
		data() {
			return {
				loading: true,
				progress: null,
				token: this.$route.query.token,
				shippings: [],
				apiErrors: []
			}
		},
		methods: {
			selectedShipping(id) {
				// progress
				this.progress = true
				
				axios({
					method: "post",
					url: "/site/api/v1/cart/shipping?token="+this.token,
					data: {
						shipping_id: id
					}
				})
				.then(response => {
					this.$router.push({
						name: 'payment',
						query: {
							token: this.token
						}
					})
					// progress
					setTimeout(() => { this.progress = false }, 500)
					console.log(response.data)
				})
				.catch((err) => {
					this.apiErrors.push(err.response)
					// progress
					setTimeout(() => { this.progress = false }, 500)
				});
			}
		},
		created () {
			axios({
				method: "get",
				url: "/site/api/v1/cart/shippings?token="+this.token
			})
			.then(response => {
				this.shippings = response.data.shippings
				if(this.shippings == null) {
					this.$router.push({
						name: 'payment',
						query: {
							token: this.token
						}
					})
				}
				// loading
				setTimeout(() => { this.loading = false }, 500)
			})
			.catch((err) => {
				this.apiErrors.push(err.response)
				// loading
				setTimeout(() => { this.loading = false }, 500)
			});
		}
	}
</script>

<style>
.shipping { padding-bottom: 10px; padding-top: 66px; }
.shipping-price { font-size: 1.3rem; color: #ff8675; font-weight: 700; }
.shipping-price small { color: #aaa; font-weight: 400; font-size: 1rem; }
</style>
